import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { InitialMetadataView } from './components/InitialMetadataView';
import { MetadataSearchResults } from './components/MetadataSearchResults';
import {
    METADATA_SEARCH,
    METADATA_STORAGE_KEY,
    metadataSearchStyles,
} from './metadata-search-helpert';

export const MetadataSearch = (): React.JSX.Element => {
    const [isInitialView, setIsInitialView] = useState<boolean>(true);
    const [searchTerms, setSearchTerms] = useState<string[]>([]);

    useEffect(() => {
        const savedMetadataSearchString =
            localStorage.getItem(METADATA_STORAGE_KEY);

        // If there's a metadata search in local storage, load the current term search and refresh results.
        if (savedMetadataSearchString) {
            setIsInitialView(false);
            setSearchTerms(JSON.parse(savedMetadataSearchString));
        }
    }, []);

    const handleSubmit = (): void => {
        setIsInitialView(false);
    };

    return (
        <Grid sx={metadataSearchStyles.pageContainer}>
            <Grid
                sx={
                    isInitialView
                        ? metadataSearchStyles.titleContainer
                        : {
                              ...metadataSearchStyles.titleContainer,
                              ...metadataSearchStyles.titleContainerResults,
                          }
                }
            >
                <Typography sx={metadataSearchStyles.pageTitleText}>
                    {METADATA_SEARCH.PAGE_TITLE}
                </Typography>
            </Grid>
            {isInitialView ? (
                <InitialMetadataView
                    onTermsChanged={setSearchTerms}
                    onSubmit={handleSubmit}
                    fieldValue={searchTerms}
                />
            ) : (
                <MetadataSearchResults initialTerms={searchTerms} />
            )}
        </Grid>
    );
};
